import { Avatar } from '@tryhackme/thm-ui-components';
import { StyledAvatarWrapper, StyledLink, StyledRoomTitle, StyledRoomTitleWrapper } from './avatar-with-room.styles';
import type { AvatarWithRoomProps } from './avatar-with-room.types';
export const AvatarWithRoom = ({
  roomCode,
  avatar,
  roomTitle
}: AvatarWithRoomProps) => <StyledLink to={`/room/${roomCode}?auto-join=true`} data-sentry-element="StyledLink" data-sentry-component="AvatarWithRoom" data-sentry-source-file="avatar-with-room.tsx">
    <StyledAvatarWrapper data-sentry-element="StyledAvatarWrapper" data-sentry-source-file="avatar-with-room.tsx">
      <Avatar avatarSrc={avatar} size="4rem" hasBorder={false} hasHover={false} data-sentry-element="Avatar" data-sentry-source-file="avatar-with-room.tsx" />
      <StyledRoomTitleWrapper data-sentry-element="StyledRoomTitleWrapper" data-sentry-source-file="avatar-with-room.tsx">
        <StyledRoomTitle data-sentry-element="StyledRoomTitle" data-sentry-source-file="avatar-with-room.tsx">{roomTitle}</StyledRoomTitle>
      </StyledRoomTitleWrapper>
    </StyledAvatarWrapper>
  </StyledLink>;